module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/picaro-bd4e9bc98236fc4c382fae4b7ced9269.png";